module.exports = __webpack_public_path__ + "img/no_image2.8fbabe14.jpg";